import Header from '../Layout/Header';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import { dataUser } from '../Helpers/util';
import './css/landing.css';
import Sidebar from "../../Component/Layout/Sidebar";
import CustomHeader from "../../Component/Layout/Header";
import { Layout } from "antd";

var UserObj = JSON.parse(dataUser());


function LandingPageNew({ }) {
    const [loader, setLoader] = useState(false)


    const mixpanelClickCO = () => {
        if (UserObj) {
            mixpanel.track('Corporate Bulk Gifting', {
                PageName: 'Diwali Gifting',
                UserEmail: UserObj.email,
                UserName: UserObj.fname + ' ' + UserObj.lname,
                UserId: UserObj.rec_id,
                CompanyId: UserObj.company_id,
                CompanyName: UserObj.company_name,
                Type: 'Corporate Bulk Gifting',
            });
        }
    }

    const mixpanelClickRW = () => {
        if (UserObj) {
            mixpanel.track('Corporate Redeemable Points', {
                PageName: 'Diwali Gifting',
                UserEmail: UserObj.email,
                UserName: UserObj.fname + ' ' + UserObj.lname,
                UserId: UserObj.rec_id,
                CompanyId: UserObj.company_id,
                CompanyName: UserObj.company_name,
                Type: 'Corporate Redeemable Points',
            });
        }
    }


    useEffect(() => {
        setLoader(true)
    }, [])


    // Sidebar Toggle
    const [collapsed, setCollapsed] = useState(true); // Sidebar collapsed state
      const toggleCollapsed = () => {
        setCollapsed((prevState) => !prevState);
      };


    localStorage.setItem('bannerStatus', "No")
    return (
        <>
        <Layout >

        <Sidebar collapsed={collapsed}/>
        
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

        <Layout className={collapsed ? 'no_pad_page PageLayout CollapsedPageLayout' : 'no_pad_page PageLayout'}>
            <div className="PageContent RewardKartLanding">
                {loader ? (
                    <div className=''>

                        <section style={{ backgroundColor: '#f5f4fa', }}>
                            <div className=''>
                                <div className="RewardLandingHeader d-flex justify-content-between">
                                    <div className='RewardLandingLogo'>
                                        <img src='img/rewards/v2/rewardkart-logo.jpg' />
                                    </div>
                                    <div className='RewardLandingH-right'>
                                        <img src='img/rewards/v2/gifting-img.jpg' />
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className='RewardLandingBody'>
                            <div className=' position-relative'>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <h2>Select from our best offerings</h2>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='ContentBox'>
                                            <div>
                                                <img src="img/rewards/v2/bulk-gifting-left.jpg" />
                                            </div>
                                            <a class="RewardLanding_BTN" role="button" href="/bulk-gifting" onClick={mixpanelClickCO}>Select this Offer</a>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='ContentBox'>
                                            <div>
                                                <img src="img/rewards/v2/bulk-gifting-right.jpg" />
                                            </div>
                                            <a class="RewardLanding_BTN" role="button" href="/reward-points" onClick={mixpanelClickRW}>Select this Offer</a>
                                        </div>
                                    </div>
                                </div>

                                <img src='img/rewards/v2/bg-decoratives.jpg' className='PageDecorative' />
                                <img src='img/rewards/v2/bg-decoratives.jpg' className='PageDecorative_Right' />

                            </div>
                        </section>



                        <div className='partnerwithusSection'>
                            <div>
                                <img src='img/rewards/v2/partner-with-us-img.jpg' />
                            </div>
                        </div>


                        <div className='RewardKartLanding_FooterLogo'>
                            <img src='img/rewards/v2/sw-logo-black.jpg' alt='smartworks' />
                        </div>

                    </div>
                ) : <div className='d-flex align-items-center justify-content-center'>
                    <img
                        className=""
                        src="img/meal-plan/loaderMealPlan.gif" height={"100px"} width={"100px"}
                    />

                </div>}

            </div>
        </Layout>

        </Layout>
        </>
    );
}
export default connect(
)(LandingPageNew);